export const COMPONENT_NAME = "ui-link";
